import React, { CSSProperties } from 'react'
import { DashboardOutlined, HowToVoteOutlined, PieChartOutlined, HelpOutline } from '@mui/icons-material'
import { IdeaIcon } from '@tumelo/designsystem'

export interface Props {
  icon: MaterialIcon
  style: CSSProperties
}

export const MaterialIconNames = ['dashboard', 'vote', 'pie-chart', 'help', 'idea'] as const
export type MaterialIcon = (typeof MaterialIconNames)[number]

export const MenuItemIconSwitch: React.FC<Props> = ({ icon, style }) => {
  switch (icon) {
    case 'dashboard':
      return <DashboardOutlined style={style} />
    case 'vote':
      return <HowToVoteOutlined style={style} />
    case 'pie-chart':
      return <PieChartOutlined style={style} />
    case 'help':
      return <HelpOutline style={style} />
    case 'idea':
      return <IdeaIcon style={style} />
    default:
      return null
  }
}
